// Display only: never use this label to infer or populate missing address fields.
const text = value => typeof value === 'string' ? value.trim() : '';
const normalized = value => text(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

export function formatLocationAddress(location) {
  if (!location) return '';
  if (location.provider !== 'megatrack') return text(location.address);
  const components = location.components || {};
  const country = text(components.country) || (location.country === 'co' ? 'Colombia' : '');
  const parts = text(location.address).split(',').map(text).filter(Boolean);
  // Keep the original description, then include geographic data omitted by the provider's label.
  // Move a trailing country to the end so the municipality and department appear before it.
  if (country && normalized(parts[parts.length - 1]) === normalized(country)) parts.pop();
  const add = value => {
    const label = text(value);
    const key = normalized(label);
    if (key && !parts.some(part => normalized(part) === key)) parts.push(label);
  };
  if (!parts.length) add(location.street_address || [components.road, components.house_number].filter(Boolean).join(' # '));
  add(location.neighborhood || components.neighborhood);
  add(location.locality || components.locality);
  add(location.municipality || components.municipality || location.city || components.city);
  add(location.state || components.state);
  add(country);
  return parts.join(', ');
}
